var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"main_box"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.dataBody)}}),(!_vm.dataBody)?_c('el-empty',{attrs:{"image":require('@/assets/images/bjtsy/no_data.png'),"image-size":400}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }